import { render, staticRenderFns } from "./SubNavigationCard.vue?vue&type=template&id=2150d68d&"
import script from "./SubNavigationCard.vue?vue&type=script&lang=ts&"
export * from "./SubNavigationCard.vue?vue&type=script&lang=ts&"
import style0 from "./SubNavigationCard.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports